<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box" v-if="ay_std_div_list!=null">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Upload Vertical And GRL Mapping.</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="sel_ay_data"
                            return-object
                            :items="ay_std_div_list"
                            item-text="ay"
                            label="Academic Year"
                            outlined
                            @change="getCourseList();"
                            persistent-hint
                            hint="Please Select Academic Year"
                        />
                    </v-col>
                    <v-col sm="2" v-if="crs!=null">
                        <v-btn class="mt-6 button" @click="proceed()">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

     <v-card class="box" v-if="course_list!=''" dense>
     <v-data-table  :headers="headers" :items="course_list" dense>
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Course List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
         <template v-slot:[`item.upload`]="{ item }">
          <div>
                <v-btn  dense class="mt-6 button" @click="proceed(item)">Upload Mapping</v-btn>
          </div>
        </template>
        <template v-slot:[`item.grl_mapping_file`]="{ item }">
             <span v-if="item.grl_mapping_file != null">
         <a :href="item.grl_mapping_file" target="_blank">
            <v-icon class="mr-2 v-icon-size" color="primary">mdi-eye</v-icon>
        </a>
             </span>
        <span v-else>--</span>
        </template>
        <template v-slot:[`item.vertical_mapping_file`]="{ item }">
        <span v-if="item.vertical_mapping_file != null">
         <a :href="item.vertical_mapping_file" target="_blank" >
            <v-icon class="mr-2 v-icon-size" color="primary">mdi-eye</v-icon>
        </a>
        </span>
        <span v-else>--</span>
        </template>
     </v-data-table>
 </v-card>

     <v-dialog v-model="upload_dialog" max-width="900px">
      <v-card>
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong>Upload Vertical And GRL Mapping.</strong>
          </v-toolbar-title>
        </v-toolbar>
        <v-col cols="12" sm="12" md="12">
          <v-card class="box">
            <v-row justify="center" dense>
          <v-col cols="12" sm="4">
            <!-- <br><br> -->
               <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio
                  label="GRL Mapping"
                  value="1"
                  color="#0f2027"
                ></v-radio>
                <v-radio
                  label="Vertical Mapping"
                  value="2"
                  color="#0f2027"
                ></v-radio>
             </v-radio-group>
          </v-col>
            </v-row>

  <v-row justify="center" dense>
<v-col cols="12">
        <v-file-input
          v-model="doc"
          placeholder="Upload attachment"
          label="File"
          dense
          prepend-icon="mdi-paperclip"
        >
          <template v-slot:selection="{ text }">
            <v-chip small label color="primary">{{ text }}</v-chip>
          </template>
        </v-file-input>
</v-col>
  </v-row>
            <v-row justify="center" dense>
              <v-btn class="button" @click="uploadGrlMappingFile()" :loading="delete_load" v-if="this.doc && this.radios">save</v-btn>
              <v-btn class="button" @click="upload_dialog = false">Close</v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-card>
    </v-dialog>
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      ay_std_div_list:[],radios:null,
      sel_ay_data:"",course_list:[],grl_mapping_file:null,vertical_mapping_file:null,upload_dialog:false,coff_id:"",doc:null,delete_load:false,
      headers:[
      { text: "Sr No", value: "srno" },
      { text: "Course", value: "course" },
      { text: "Standard", value: "standard" },
      { text: "GRL Mapping", value: "grl_mapping_file" },
      { text: "Vertical Mapping", value: "vertical_mapping_file" },
      { text: "Upload", value: "upload" },
      ],
  }),
   methods: {
    proceed(item){
        this.upload_dialog=true
        this.coff_id=item.id
    },
     uploadGrlMappingFile() {
                let formData = new FormData();
                    //console.log(this.file.size)
                    formData.append("coff_id", this.coff_id);
                    formData.append("mapping_id", this.radios);
                    formData.append("doc", this.doc);
                this.overlay = true;
                this.delete_load = true;
                axios
                    .post("/LessonPlanning/saveUploadMappings", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("green", "Uploaded Successfully...");
                            this.getCourseList()
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.upload_dialog=false
                        this.delete_load = false;
                        this.getCourseList()
                    });
                // this.std_div_list = null;
                // this.sel_std_data = null;
                // this.div_list = null;
                // this.div = null;
                // this.std_div_list = this.sel_ay_data.std_list;
    },
     getCourseList() {
                (this.course_list = [])
                const data = {
                    academicYear: this.sel_ay_data.ay_id,
                };
                this.overlay = true;
                axios
                    .post("/LessonPlanning/getCourseList", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.course_list = res.data.coff_list;
                            // this.showSnackbar("green", res.data.snackbar);
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
                // this.std_div_list = null;
                // this.sel_std_data = null;
                // this.div_list = null;
                // this.div = null;
                // this.std_div_list = this.sel_ay_data.std_list;
    },
     onload() {
        axios
            .post("/commonAPI/get_ay_std_div")
            .then((res) => {
                this.ay_std_div_list = res.data.data;
                this.sel_ay_data = res.data.curr_ay;
                this.aws_path = res.data.aws_path;
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            })
            .finally(() => {});
            },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onload();
  },
  watch: {},
};
</script>
<style scoped>
</style>